import * as React from "react";
import
{
    getProgramOverview,
    getInformationBar,
    getQuoteWithProtrait,
    getQuote,
    getHeroBanner,
    getImage,
    getImageGallery,
    getVideo,
    getAccordionList,
    getButtonList,
    getRichText,
    getTabs,
    getOEmbed,
    getShowWithPoster,
    getReviews,
    getCast,
    getSubMenu,
    getDivider,
    getCodeSnippet,
    getPopper, getHeroBannerWithCalendarControl, getSharedModule
} from "../../util/ModuleHelper";
import { CONTROL_TYPES, Control } from "../../typings/grid";
import { logWarning } from "../../errors";

interface GridControlProps
{
    control: CONTROL_TYPES;
}

class GridControl extends React.Component<GridControlProps>
{
    render()
    {
        const control = this.props.control;

        switch (control._contentType)
        {
            case "gridEditorProgramOverview": {
                return getProgramOverview();
            }
            case "gridEditorInformationBar": {
                return getInformationBar(control);
            }
            case "gridEditorQuoteWithPortrait": {
                return getQuoteWithProtrait(control);
            }
            case "gridEditorQuote": {
                return getQuote(control);
            }
            case "gridEditorHeroBanner": {
                return getHeroBanner(control);
            }
            case "gridEditorImage": {
                return getImage(control);
            }
            case "gridEditorImageGallery": {
                return getImageGallery(control);
            }
            case "gridEditorVideo": {
                return getVideo(control);
            }
            case "gridEditorTabs": {
                return getTabs(control);
            }
            case "gridEditorAccordionList": {
                return getAccordionList(control);
            }
            case "gridEditorButtonList": {
                return getButtonList(control);
            }
            case "gridEditorRichText": {
                return getRichText(control);
            }
            case "gridEditorEmbed": {
                return getOEmbed(control);
            }
            case "gridEditorShowWithPoster": {
                return getShowWithPoster(control);
            }
            case "gridEditorReviews": {
                return getReviews(control);
            }
            case "gridEditorCast": {
                return getCast(control);
            }
            case "gridEditorSubMenu": {
                return getSubMenu(control);
            }
            case "gridEditorDivider": {
                return getDivider();
            }
            case "gridEditorCodeSnippet": {
                return getCodeSnippet(control);
            }
            case "gridEditorPopper": {
                return getPopper(control);
            }
            case "gridEditorHeroBannerWithCalendar": {
                return getHeroBannerWithCalendarControl(control);
            }
            case "gridEditorSharedModule": {
                return getSharedModule(control);
            }
            case "AreaSettings": {
                return null;
            }
            default: {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const neverControl: never = control;
                logWarning(`${(control as Control)._contentType} control is not being mapped.`, control);
            }
        }

        return null;
    }
}

export default GridControl;
